export var SubjectNamingStrategy;
(function (SubjectNamingStrategy) {
    SubjectNamingStrategy["SUBJECT_NAMING_STRATEGY_TOPIC_NAME"] = "topic_name";
    SubjectNamingStrategy["SUBJECT_NAMING_STRATEGY_RECORD_NAME"] = "record_name";
    SubjectNamingStrategy["SUBJECT_NAMING_STRATEGY_TOPIC_RECORD_NAME"] = "topic_record_name";
})(SubjectNamingStrategy || (SubjectNamingStrategy = {}));
